import React from 'react'

export default function  Loader (props){
    return(
        <div className="flexhvc">
            <img src="https://www.thun.com/static/version1571221457/frontend/Thun/default/en_US/images/loader-3.gif" 
            width='100'
            height='100'
            alt="Page loader" />
        </div>
    )
}